import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@jsverse/transloco';
import {CoreModule} from '../../core/core.module';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {HealthCenterComponent} from './health-center.component';
import {SharedModule} from '../../shared/shared.module';
import {MatSelect} from '@angular/material/select';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {HealthCentersListComponent} from './health-centers-list/health-centers-list.component';
import {HealthCenterRestApiService} from './services/http/health-center-rest-api.service';
import {CreateEditHealthCenterComponent} from './create-edit-health-center/create-edit-health-center.component';
import {HealthCenterResolver} from './services/resolver/health-center.resolver';
import {HealthCentreService} from './services/health-centre.service';
import {HealthCenterDetailsComponent} from './health-center-details/health-center-details.component';
import {HealthCenterOrdersListComponent} from './health-center-orders-list/health-center-orders-list.component';
/* eslint-disable max-len */
import {SensorOrderShippingDialogComponent} from './sensor-order-shipping-dialog/sensor-order-shipping-dialog.component';

/* eslint-enable max-len */

@NgModule({
  declarations: [
    HealthCenterComponent,
    HealthCentersListComponent,
    CreateEditHealthCenterComponent,
    HealthCenterDetailsComponent,
    HealthCenterOrdersListComponent,
    SensorOrderShippingDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    ReactiveFormsModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatInputModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,

    SharedModule,
    CoreModule,
    MatSelect,
    MatOption,
    MatAutocompleteTrigger,
    MatAutocomplete,
  ],
  providers: [
    HealthCenterRestApiService,
    HealthCenterResolver,
    HealthCentreService,
  ],
})
export class HealthCenterModule {
}
